import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface ChatBubbleProps extends IconProps {
  color?: TIconColor;
}

const ChatBubble = ({ size, variant, className, color = 'white' }: ChatBubbleProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      d="M2.80398 1.89222C4.2422 1.69954 5.70967 1.6001 7.20005 1.6001C8.69043 1.6001 10.1579 1.69954 11.5961 1.89222C12.5935 2.02584 13.3393 2.77874 13.5439 3.70674C13.394 3.67868 13.2401 3.65998 13.0825 3.65138C12.4592 3.61733 11.8315 3.6001 11.2 3.6001C10.5686 3.6001 9.94092 3.61733 9.31757 3.65138C7.38335 3.75702 6.00005 5.38201 6.00005 7.19845V8.99025C6.00005 10.121 6.53611 11.1782 7.40838 11.8403L5.02431 14.2244C4.85271 14.396 4.59464 14.4473 4.37044 14.3544C4.14623 14.2616 4.00005 14.0428 4.00005 13.8001V11.0459C3.59923 11.0071 3.2005 10.9611 2.80399 10.908C1.62677 10.7503 0.800049 9.72983 0.800049 8.57701V4.22318C0.800049 3.07038 1.62675 2.04993 2.80398 1.89222Z"
      fill="currentColor"
    />
    <path
      d="M11.2 4.8001C10.5904 4.8001 9.98458 4.81674 9.38301 4.84959C8.12582 4.91825 7.20005 5.97779 7.20005 7.19845V8.99025C7.20005 10.2053 8.1174 11.2617 9.36819 11.3382C9.5391 11.3486 9.71035 11.3578 9.88195 11.3656C10.0421 11.3729 10.1894 11.4379 10.2962 11.5448L12.1758 13.4244C12.3474 13.596 12.6055 13.6473 12.8297 13.5544C13.0539 13.4616 13.2 13.2428 13.2 13.0001V11.3437C14.3621 11.1879 15.2 10.1733 15.2 9.01194V7.19845C15.2 5.97779 14.2743 4.91825 13.0171 4.84959C12.4155 4.81674 11.8097 4.8001 11.2 4.8001Z"
      fill="currentColor"
    />
  </svg>
);

export default ChatBubble;
